import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';
import moment from 'moment-timezone';

import GET_POSSIBLE_COACHING_SESSIONS_FOR_COACH_QUERY from 'coaching/queries/GetPossibleCoachingSessionsForCoach.gql';
import {
  GetPossibleCoachingSessionsForCoach,
  GetPossibleCoachingSessionsForCoachVariables,
} from 'coaching/queries/__generated__/GetPossibleCoachingSessionsForCoach';
import { TimeslotFrequencyInput } from 'globalTypes';

export type CoachingSessionSlot = {
  coachUuid: string;
  startDateTime: moment.Moment;
  endDateTime: moment.Moment;
};

export type CoachingTimeOff = {
  startDate: moment.Moment;
  endDate: moment.Moment;
};

export type AvailableSessionsContainerProps = {
  coachUuid: string;
  subjectUuid: string;
  frequency: TimeslotFrequencyInput;
  startDateTimeRange: string;
  endDateTimeRange: string;
  participantUuid: string;
  children: (props: {
    sessionSlots?: CoachingSessionSlot[];
    timeOff?: CoachingTimeOff[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetPossibleCoachingSessionsForCoachContainer(
  props: AvailableSessionsContainerProps
) {
  return (
    <Query<GetPossibleCoachingSessionsForCoach, GetPossibleCoachingSessionsForCoachVariables>
      query={GET_POSSIBLE_COACHING_SESSIONS_FOR_COACH_QUERY}
      variables={{
        coachUuid: props.coachUuid,
        subjectUuid: props.subjectUuid,
        frequency: props.frequency,
        startDateTimeRange: props.startDateTimeRange,
        endDateTimeRange: props.endDateTimeRange,
      }}>
      {({ loading, error, data }) => {
        return props.children({
          sessionSlots: data?.coaching?.getPossibleCoachingSessionsForCoach.availableSessions.map(
            res => ({
              coachUuid: res.coachUuid,
              startDateTime: moment(res.startDateTime),
              endDateTime: moment(res.endDateTime),
            })
          ),
          timeOff: data?.coaching?.getPossibleCoachingSessionsForCoach.timeOff.map(res => ({
            startDate: moment(res.startDate),
            endDate: moment(res.endDate),
          })),
          loading,
          error,
        });
      }}
    </Query>
  );
}
